var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SubCollection, Collection, Field } from '@1amageek/ballcap';
import { Base } from '.';
export class Clinic extends Base {
    constructor() {
        super(...arguments);
        this.notices = new Collection();
    }
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('clinics');
    }
}
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Clinic.prototype, "isNoticeEmailJobApply", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Clinic.prototype, "isNoticeEmailJobCompleted", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Clinic.prototype, "isNoticeEmailAttendance", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Clinic.prototype, "isNoticeEmailModificationRequest", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Clinic.prototype, "isNoticeEmailReviewPost", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Clinic.prototype, "isNoticeEmailChatMessage", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "noticeCount", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], Clinic.prototype, "notices", void 0);
